import React from "react";
import "../style/heroSection.css";
import heroimage from "../images/hero.png";
import truck1image from "../images/truck1.png";
import truck2image from "../images/truck2.png";

const HeroSection = () => {
  return (
    <section className="hero">
      <div className="hero-bg-split">
      <div
          className="hero-bg-left"
          style={{ backgroundImage: `url(${truck1image})` }}
        ></div>
        <div
          className="hero-bg-right"
          style={{ backgroundImage: `url(${truck2image})` }}
        ></div>
      </div>
      <div className="hero-content">
        <div className="hero-left">

          <h1 className="hero-title">
            Waste Gone,<br />Space Back.
          </h1>

          <p className="hero-subtitle">
            Fast, reliable and affordable skip bin hire <br/> services for
            homes, businesses and <br/> construction sites.
          </p>

          <div className="hero-buttons">
            <a href="/booking" className="btn-primary">BOOK NOW</a>
            <a href="#bins-section" className="btn-secondary">VIEW BINS</a>
          </div>

          <div className="hero-features">
            <div className="feature-item">
              <span className="feature-icon">
                <svg viewBox="0 0 24 24" width="22" height="22" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 12l3-7h14l3 7M2 12v6a1 1 0 001 1h18a1 1 0 001-1v-6M2 12h20" stroke="#F5821F" strokeWidth="1.5" fill="none" strokeLinejoin="round" />
                </svg>
              </span>
              <div>
                <p className="feature-title">Same Day Delivery</p>
                <p className="feature-desc">Fast &amp; reliable</p>
              </div>
            </div>

            <div className="feature-item">
              <span className="feature-icon">
                <svg viewBox="0 0 24 24" width="22" height="22" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C9 6 6 9.5 6 13a6 6 0 0012 0c0-3.5-3-7-6-11z" stroke="#F5821F" strokeWidth="1.5" fill="none" strokeLinejoin="round" />
                </svg>
              </span>
              <div>
                <p className="feature-title">Affordable Pricing</p>
                <p className="feature-desc">No hidden fees</p>
              </div>
            </div>

          </div>
        </div>

        <div className="hero-right">
          <img src={heroimage} alt="Jerry's Bins skip bin" className="hero-bin-img" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;